// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MbpTr","col":"styles_col__11yyh"};